<template>
<!-- <List :searchText="searchText" :plantIdList="" :deviceIdList="" ref="List"></List> -->
<div>
	<div class="alarmList tableScope bgContent">
		<div class="table table-5x tra-fast posR" fillHeight="lastHeight,-.alarmList .tableBatch">
			<Loading ref="Loading"></Loading>
			<!--授权商家列表-->
			<div v-if="list.length && type==1" class="cb">
				<div class="scrollHide tra-fast bdLight-right fL"
					 :style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length+stage.setting.system.autoColumnWidth[1]}"
					 scrollFloatX="false">
					<div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
						<div :title="getLanguageStr('word1963','商家名称')">{{getLanguageStr('word1963','商家名称')}}</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table>
							<tbody class="bdLight-bottom_E emptyToken_EE">
							<tr v-for="(obj,index) in list" :key="index" >
								<td class="curP">
									<div :title="obj.orgDto.name">{{obj.orgDto.name?obj.orgDto.name:'--'}}</div>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="operate scrollHide" fillHeight="lastHeight,-.tableBatch" :mode="stage.setting.loc.operateMode" v-permissions="'A/B/A20'" permission-type="none">
					<div class="tableSys head noSelect b cField bdLight-bottom bgContent tra-fast_E" scrollFloatY="false">
						<div class="cb vaM_E">
							<span class="lh13" :title="$t('word47',['操作'])">{{$t("word47",["操作"])}}</span>
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast bgContent" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table>
							<thead class="head-token">
							<tr>
								<th></th>
							</tr>
							</thead>
							<tbody class="bdLight-bottom_E textCut_EE">
							<tr v-for="(obj,index) in list" :key="index">
								<td class="cSub fSub w3x_E mr05x_E hover-c-main_E tra-fast_E vaM_E">
									<button  v-if="!entityRelId||(entityRelId && obj.entityRel.targetEntityId==userInfo.orgUser.orgId)" v-permissions="'A/B/A20'" permission-type="none" class="hover-f-main" type="button" @click="deleteRelation(obj.entityRel.id)" :title="$t('cmd9',['删除'])">
										<Icon name="ico-recycle" class="ico"/>
									</button>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div scroll="{'axis':'x'}">
					<div class="tableSys head noSelect b cField bdLight-bottom"
						 :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}"
						 scrollFloatY="false">
						<div :title="$t('word1656',['联系人姓名'])">{{$t('word1656',['联系人姓名'])}}</div>
						<div :title="getLanguageStr('word658','手机号')">{{getLanguageStr('word658','手机号')}}</div>
						<div :title="getLanguageStr('word68','邮箱')">{{getLanguageStr('word68','邮箱')}}</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
								<tr v-for="(obj,index) in list" :key="index" class="tra-fast_E">
									<td>{{obj.orgDto.adminName?obj.orgDto.adminName:'--'}}</td>
									<td>{{obj.orgDto.adminPhoneNumber?obj.orgDto.adminPhoneNumber:'--'}}</td>
									<td>{{obj.orgDto.adminEmail?obj.orgDto.adminEmail:'--'}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<!--授权用户列表 -->
			<div v-if="list.length && type==2" class="cb">
				<div class="scrollHide tra-fast bdLight-right fL"
					 :style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length+stage.setting.system.autoColumnWidth[1]}"
					 scrollFloatX="false">
					<div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
						<div :title="getLanguageStr('word67','姓名')">{{getLanguageStr("word67","姓名")}}</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table>
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
							<tr v-for="(obj,index) in list" :key="index" >
								<td class="curP">
									<div :title="obj.userInfoDto.userInfo.name">{{obj.userInfoDto.userInfo.name?obj.userInfoDto.userInfo.name:'--'}}</div>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="operate scrollHide" fillHeight="lastHeight,-.tableBatch" :mode="stage.setting.loc.operateMode" v-permissions="'A/B/A18'" permission-type="none">
					<div class="tableSys head noSelect b cField bdLight-bottom bgContent tra-fast_E" scrollFloatY="false">
						<div class="cb vaM_E">
							<span class="lh20" :title="$t('word47',['操作'])">{{$t("word47",["操作"])}}</span>
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast bgContent" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table>
							<thead class="head-token">
							<tr>
								<th></th>
							</tr>
							</thead>
							<tbody class="bdLight-bottom_E textCut_EE">
							<tr v-for="(obj,index) in list" :key="index">
								<td class="cSub fSub w3x_E mr05x_E hover-c-main_E tra-fast_E vaM_E">
									<button v-if="!entityRelId" v-permissions="'A/B/A18'" permission-type="none" class="hover-f-main" type="button" @click="deleteRelation(obj.entityRel.id)" :title="$t('cmd9',['删除'])">
										<Icon name="ico-recycle" class="ico"/>
									</button>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div scroll="{'axis':'x'}">
					<div class="tableSys head noSelect b cField bdLight-bottom"
						 :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}"
						 scrollFloatY="false">
						<div :title="getLanguageStr('word658','手机号')">{{getLanguageStr('word658','手机号')}}</div>
						<div :title="getLanguageStr('word68','邮箱')">{{getLanguageStr('word68','邮箱')}}</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
							<tr v-for="(obj,index) in list" :key="index" class="tra-fast_E">
								<td>{{obj.userInfoDto.userInfo.phoneNumber?obj.userInfoDto.userInfo.phoneNumber:'--'}}</td>
								<td>{{obj.userInfoDto.userInfo.email?obj.userInfoDto.userInfo.email:'--'}}</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<!-- 内部成员列表 -->
			<div v-if="list.length && type==3" class="cb">
				<div class="scrollHide tra-fast bdLight-right fL"
					 :style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length+stage.setting.system.autoColumnWidth[1]}"
					 scrollFloatX="false">
					<div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
						<div :title="getLanguageStr('word1740','成员姓名')">{{getLanguageStr("word1740","成员姓名")}}</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table>
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
							<tr v-for="(obj,index) in list" :key="index" >
								<td class="curP">
									<div :title="obj.orgUserDto.userInfo.name">{{obj.orgUserDto.userInfo.name?obj.orgUserDto.userInfo.name:'--'}}</div>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="operate scrollHide" fillHeight="lastHeight,-.tableBatch" :mode="stage.setting.loc.operateMode" v-permissions="'A/B/A15'" permission-type="none">
					<div class="tableSys head noSelect b cField bdLight-bottom bgContent tra-fast_E" scrollFloatY="false">
						<div class="cb vaM_E">
							<span class="lh20" :title="$t('word47',['操作'])">{{$t("word47",["操作"])}}</span>
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast bgContent" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table>
							<thead class="head-token">
							<tr>
								<th></th>
							</tr>
							</thead>
							<tbody class="bdLight-bottom_E textCut_EE">
							<tr v-for="(obj,index) in list" :key="index">
								<td class="cSub fSub w3x_E mr05x_E hover-c-main_E tra-fast_E vaM_E">
									<button v-permissions="'A/B/A15'" permission-type="none" class="hover-f-main" type="button" @click="deleteRelation(obj.orgUserDto.userInfo.id)" :title="$t('cmd9',['删除'])">
										<Icon name="ico-recycle" class="ico"/>
									</button>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div scroll="{'axis':'x'}">
					<div class="tableSys head noSelect b cField bdLight-bottom"
						 :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}"
						 scrollFloatY="false">
						<div :title="$t('word90',['角色'])">{{$t('word90',['角色'])}}</div>
						<div :title="getLanguageStr('word1215','所属组')">{{getLanguageStr('word1215','所属组')}}</div>
						<div :title="getLanguageStr('word658','手机号')">{{getLanguageStr('word658','手机号')}}</div>
						<div :title="getLanguageStr('word68','邮箱')">{{getLanguageStr('word68','邮箱')}}</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.alarmList .tableBatch" scroll="{'group':'alarmList'}">
						<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
							<tr v-for="(obj,index) in list" :key="index" class="tra-fast_E">
								<td v-if="obj.role">{{getTypeText(obj.role.roleId,'roleType')?getTypeText(obj.role.roleId,'roleType'):obj.role.roleName}}</td>
								<td v-else>{{'--'}}</td>
								<td>{{obj.orgUserDto.groupName?obj.orgUserDto.groupName:'--'}}</td>
								<td>{{obj.orgUserDto.userInfo.phoneNumber?obj.orgUserDto.userInfo.phoneNumber:'--'}}</td>
								<td>{{obj.orgUserDto.userInfo.email?obj.orgUserDto.userInfo.email:'--'}}</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<no-result v-show="!list.length"></no-result>
		</div>
		<div class="tableBatch bgContent cSub tra-fast" :class="{disable:!list.length}">
			<Pagination :pagination="pagination" :getList="getList" ref="Pagination"></Pagination>
		</div>
	</div>
</div>
</template>
<script>
import {mapGetters} from 'vuex'
import {getLanguageStr} from '@/util/language'
import * as lib from '@/util/lib.js'

import StatusIco from '@/components/common/ui/StatusIco.vue'
import Pagination from '@/components/common/ui/Pagination.vue'
import NoResult from '@/components/common/ui/NoResult'
import Loading from '@/components/common/ui/Loading'

import {AssociatedPerson} from '@/api/maintain/plant/list.js'
import {relatedBusiness, delRelatedBus, relatedUser, delRelatedUser} from '@/api/maintain/plant/relative.js'

// import * as baseApi from '@/api/base'

export default {
  name: 'StationRelateList',
  components: {StatusIco, Pagination, NoResult, Loading},
  props: {
    entityRelId: {// 表明电站是不是外部给的
      type: Number,
      default: null
    }
  },
  data () {
    return {
      stage,
      floatColumn: ['a'],
      type: 1, // 1:关联商家 2：关联用户 3：内部关联
      column: [],
      stationId: '',
      pagination: {
        request: {page: 1, size: 20},
        total: 0
      }, // 分页数据
      requestData: {
        // 'order.direction': 'DESC',
        // 'order.property': 'id'
      }, // api请求发送数据
      list: [],
      station: {}, // 电站详情
      basicInfo: {}, // 详情-电站信息
      basicCost: {}, // 详情-电站信息-电价
      associatedPerson: {}, // 关联人员
      'orderDirection': this.$route.query.orderDir || 'DESC', //, ASC
      'orderProperty': this.$route.query.orderPpt || 'alertTime',
      scopedType: 0
    }
  },
  methods: {
    doPermissions: lib.doPermissions,
    getLanguageStr,
    getTypeText: lib.getTypeText,
    floatFix: lib.floatFix,
    timeFormat: lib.timeFormat,
    convertData: lib.convertData,
    operateModeChange: lib.operateModeChange,
    show: function (data) {
      // if(data.entityRelId) this.entityRelId=data.entityRelId;
      this.getList()
    },
    reset () {
      if (this.type == 1) {
        this.column = ['1', '2', '3']
      } else if (this.type == 2) {
        this.column = ['1', '2']
      } else {
        this.column = ['1', '2', '3', '4']
      }
      this.pagination = {
        request: {page: 1, size: 20},
        total: 0
      }
      this.list = []
    },
    getList: function (data) {
      //  data={
      // 	type, 1:关联商家 2：关联用户 3：内部关联用户
      // 	stationId,
      // 	systemId
      //  }
	  let language = stage.languageId
	  if(data){
		this.type = data.type
		this.stationId = data.stationId
		this.reset()
	  }
      this.$refs.Loading.show()
      this.requestData = {...this.requestData, ...this.pagination.request}
      this.requestData.language = language
      if (this.type == 1) {
        relatedBusiness(this.stationId, this.requestData).then(res => {
          trace(this.userInfo)
          this.pagination.total = res.total
          // this.list = res.data
          if (res.total > 0) {
            let existNameList = res.data.filter(el => el.orgDto.nameList.length)
            existNameList.forEach((val, index) => {
              if (val.orgDto.nameList.length == 1) {
                val.orgDto.name = val.orgDto.nameList[0].name
              } else {
                let FilterName = val.orgDto.nameList.filter(el => el.language === language)
                if (FilterName.length) {
                  val.orgDto.name = FilterName[0].name
                } else {
                  let filterEn = val.orgDto.nameList.filter(el => el.language === 'en')
                  if (filterEn.length) {
                    val.orgDto.name = filterEn[0].name
                  } else {
                    val.orgDto.name = val.orgDto.nameList[0].name
                  }
                }
              }
            })
            this.list = existNameList
            // this.list.forEach(el => {
            // 	if (el.orgDto.nameList.length > 0) {
            // 		el.orgDto.nameList.forEach(attr => {
            // 			if (attr.language == language||el.orgDto.nameList==1||attr.language=='en') {
            // 				el.orgDto.name = attr
            // 			}else{
            // 				el.orgDto.name=el.orgDto.nameList[0]
            // 			}
            // 		})
            // 	}
            // })
          }
          this.$refs.Loading.hide()
          this.$nextTick(() => {
            lib.setScroll($(this.$el).find('[scroll]'))
            lib.fillHeight()
          })
        }, error => {
          this.$refs.Loading.hide()
          !_.isEmpty(error) && this.$notify(error)
        })
      } else if (this.type == 2) {
        relatedUser(this.stationId, this.requestData).then(res => {
          this.pagination.total = res.total
          this.list = res.data.filter(el => el.userInfoDto)
          this.$refs.Loading.hide()
          this.$nextTick(() => {
            lib.setScroll($(this.$el).find('[scroll]'))
            lib.fillHeight()
          })
        }, error => {
          !_.isEmpty(error) && this.$notify(error)
          this.$refs.Loading.hide()
        })
      } else {
        AssociatedPerson(this.stationId, this.requestData).then(res => {
          this.pagination.total = res.total
          this.list = res.data
          this.$refs.Loading.hide()
          this.$nextTick(() => {
            lib.setScroll($(this.$el).find('[scroll]'))
            lib.fillHeight()
          })
        }, error => {
          !_.isEmpty(error) && this.$notify(error)
          this.$refs.Loading.hide()
        })
      }
    },
    deleteRelation (id) {
      this.deleteId = id
      this.$emit('del', id)
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/userInfo'
    })
  },
  mounted () {
    lib.fillHeight()
    lib.setScroll($(this.$el).find('[scroll]'))
  }
}
</script>
<style lang="scss" scoped>
$operateMin:4em + 1;
$operateMax:4em * 1 + 1;
.operate{
	>*{width:$operateMax;}
	&[mode]{width:$operateMax;}
	&[mode="min"]{width:$operateMin;
		&:hover{transform:translateX($operateMin - $operateMax);}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/plant/relate/part/List.vue